/**
 * PJAX Plugin Fix
 * 
 * This script ensures that the jQuery pjax plugin is properly initialized
 * and available to all scripts that depend on it.
 */

(function() {
  // Wait for DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    console.log('PJAX Plugin Fix: Initializing');
    
    // Function to check if jQuery is available
    function checkJQuery() {
      return (typeof jQuery !== 'undefined');
    }
    
    // Function to check if pjax plugin is available
    function checkPjax() {
      return (checkJQuery() && typeof jQuery.fn.pjax !== 'undefined');
    }
    
    // Function to fix pjax plugin
    function fixPjaxPlugin() {
      if (!checkJQuery()) {
        console.log('PJAX Plugin Fix: jQuery not available yet, waiting...');
        setTimeout(fixPjaxPlugin, 50);
        return;
      }
      
      console.log('PJAX Plugin Fix: jQuery is available, checking pjax plugin');
      
      // Store a reference to jQuery
      var $ = jQuery;
      
      // Check if pjax is already available
      if (typeof $.fn.pjax !== 'undefined') {
        console.log('PJAX Plugin Fix: pjax plugin already available');
        ensurePjaxIsGlobal();
        return;
      }
      
      // Check if pjax is available in the global scope but not attached to jQuery
      if (typeof window.pjax !== 'undefined') {
        console.log('PJAX Plugin Fix: Found pjax in global scope, attaching to jQuery');
        $.fn.pjax = window.pjax;
        ensurePjaxIsGlobal();
        return;
      }
      
      // Look for pjax in various possible locations
      if (typeof $.pjax !== 'undefined' && typeof $.fn.pjax === 'undefined') {
        console.log('PJAX Plugin Fix: Found $.pjax but not $.fn.pjax, fixing...');
        
        // Define the main pjax function on jQuery.fn
        $.fn.pjax = function(selector, container, options) {
          return this.on('click.pjax', selector, function(event) {
            var opts = $.extend({}, options);
            if (!opts.container) {
              opts.container = $(this).attr('data-pjax');
            }
            $.pjax.click(event, opts);
          });
        };
        
        ensurePjaxIsGlobal();
        return;
      }
      
      // If we get here, we need to load the pjax script
      console.log('PJAX Plugin Fix: pjax plugin not found, checking if script is loaded');
      
      // Check if the script is already in the page
      var pjaxScriptLoaded = false;
      var scripts = document.getElementsByTagName('script');
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].src && scripts[i].src.indexOf('jquery.pjax') !== -1) {
          pjaxScriptLoaded = true;
          break;
        }
      }
      
      if (pjaxScriptLoaded) {
        console.log('PJAX Plugin Fix: pjax script is loaded but not initialized, waiting...');
        // Script is loaded but not initialized, wait a bit and try again
        setTimeout(fixPjaxPlugin, 100);
      } else {
        console.log('PJAX Plugin Fix: pjax script not found, cannot fix automatically');
        // We can't load the script dynamically as we don't know the correct path
        // Instead, we'll create a dummy implementation to prevent errors
        createDummyPjax();
      }
    }
    
    // Function to ensure pjax is available in all possible global scopes
    function ensurePjaxIsGlobal() {
      if (typeof jQuery.fn.pjax !== 'undefined') {
        // Make sure pjax is available to all possible jQuery instances
        if (typeof $ !== 'undefined' && $ !== jQuery && typeof $.fn.pjax === 'undefined') {
          $.fn.pjax = jQuery.fn.pjax;
        }
        
        // Make sure $.pjax is also available
        if (typeof jQuery.pjax === 'undefined' && typeof jQuery.fn.pjax !== 'undefined') {
          jQuery.pjax = {
            click: function(event, options) {
              var link = event.currentTarget;
              var $link = jQuery(link);
              
              var defaults = {
                url: link.href,
                container: $link.attr('data-pjax')
              };
              
              var opts = jQuery.extend({}, defaults, options);
              event.preventDefault();
              jQuery(opts.container).load(opts.url);
            },
            submit: function(event, options) {
              event.preventDefault();
              var form = event.currentTarget;
              var $form = jQuery(form);
              
              var defaults = {
                url: $form.attr('action'),
                container: $form.attr('data-pjax')
              };
              
              var opts = jQuery.extend({}, defaults, options);
              jQuery(opts.container).load(opts.url);
            }
          };
        }
        
        console.log('PJAX Plugin Fix: pjax plugin is now globally available');
      }
    }
    
    // Function to create a dummy pjax implementation to prevent errors
    function createDummyPjax() {
      console.log('PJAX Plugin Fix: Creating dummy pjax implementation');
      
      // Create a simple dummy implementation that does basic navigation
      jQuery.fn.pjax = function(selector, container, options) {
        return this.on('click.pjax', selector, function(event) {
          // Prevent the default action
          event.preventDefault();
          
          // Get the URL from the link
          var url = this.href;
          
          // Navigate to the URL normally
          if (url) {
            window.location.href = url;
          }
        });
      };
      
      // Create the $.pjax object with dummy methods
      jQuery.pjax = {
        click: function(event, options) {
          event.preventDefault();
          var url = event.currentTarget.href;
          if (url) {
            window.location.href = url;
          }
        },
        submit: function(event, options) {
          // Let the form submit normally
          return true;
        },
        reload: function() {
          window.location.reload();
        }
      };
      
      console.log('PJAX Plugin Fix: Dummy pjax implementation created');
    }
    
    // Start the fix process
    fixPjaxPlugin();
    
    // Set up a MutationObserver to detect when new scripts are added
    // This helps catch dynamically loaded jQuery or pjax
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.tagName === 'SCRIPT') {
              // If a new script is added, check if we need to fix pjax again
              if (node.src && (node.src.indexOf('jquery') !== -1 || node.src.indexOf('pjax') !== -1)) {
                setTimeout(fixPjaxPlugin, 100);
              }
            }
          });
        }
      });
    });
    
    // Start observing the document
    observer.observe(document.documentElement, { 
      childList: true, 
      subtree: true 
    });
    
    console.log('PJAX Plugin Fix: Initialization complete');
  });
})();
